module.exports = __webpack_public_path__ + "img/arrow-down-a-z.769575f3.svg";